import React from "react";

export default function Recipe({
  imageUrl,
  tags,
  title,
  difficulty,
  duration,
}) {
  return (
    <div className="recipe">
      <img src={imageUrl} />
      <div>
        <ul>
          {tags.map((t) => (
            <li key={t.attributes.name}>{t.attributes.name}</li>
          ))}
        </ul>
      </div>
      <h4>{title}</h4>
      <span>
        {difficulty} · {duration}
      </span>
    </div>
  );
}
